module.exports = __webpack_public_path__ + "img/20210206_180509.7b6f5e85.jpg";